import React from 'react';
import { analysisPlatformTopInfo } from '@/pages/intelligence/_config/storeRank/utils';
import { getDataSourceInfo } from '@/pages/intelligence/utils/getDataSourceInfo';
import { MOBILE_STORE_RANK_TOPS_NAMES_MAPPING } from '@/pages/intelligence/_config/storeRank/config';

import type { IGameType, ITranslater } from '@/pages/intelligence/types/common';

export const getOptionsWithModification = (entityType: IGameType, sources: string[], translater: ITranslater, withImage: boolean = false) => {
  if (!Array.isArray(sources)) return [];
  return sources.map((source) => {
    const { platform, top } = analysisPlatformTopInfo(source);
    const { /* name: platformName,*/ icon: platformIcon } = getDataSourceInfo(entityType, platform);
    const topNameLocaleKey = MOBILE_STORE_RANK_TOPS_NAMES_MAPPING?.[top];
    const topNameLocaleText = topNameLocaleKey ? translater({ id: topNameLocaleKey }) : top;
    // const name = `${platformName} ${topNameLocaleText}`;
    const name = topNameLocaleText;

    if (withImage) {
      return {
        value: source,
        text: name,
        img: platformIcon
      };
    }
    return {
      value: source,
      text: (
        <div className="dbi-filter-selector-option-node">
          <img className="dbi-filter-selector-option-node-icon" src={platformIcon} />
          <span className="dbi-filter-selector-option-node-text">{name}</span>
        </div>
      ),
    };
  });
};


export const getOptions = (entityType: IGameType, sources: string[], translater: ITranslater) => {
  return getOptionsWithModification(entityType, sources, translater);
};

export const getStoreRankPlatformOptions = (entityType: IGameType, sources: string[], translater: ITranslater) => {
  return getOptionsWithModification(entityType, sources, translater, true);
};
